import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Response } from '@angular/http';


import 'rxjs/Rx'


import {JhiLanguageService} from 'ng-jhipster/src/language/language.service';
import {  DataUtils } from 'ng-jhipster';
import {Principal} from '../../shared/auth/principal.service';
import {EventManager} from 'ng-jhipster/src/service/event-manager.service';
import {Account} from '../../shared/user/account.model';
import {SellerDashboardService} from './seller-dashboard.service';
import {Seller} from '../../entities/seller/seller.model';
import {Model} from '../../entities/model/model.model';
import {AlertService} from 'ng-jhipster/src/service/alert.service';
import {Resource} from '../../entities/resource/resource.model';

@Component( {
    selector: 'dcs-seller-dashboard',
    templateUrl: './seller-dashboard.component.html',
    styles: [ `.upload-new-file {
    width: 20rem
    }` ]
} )
export class SellerDashboardComponent implements OnInit {

    account: Account;
    seller: Seller
    models: Model[];
    files: Resource[];
    upload: boolean = false;

    constructor(private jhiLanguageService: JhiLanguageService,
                private principal: Principal,
                private eventManager: EventManager,
                private sellerService: SellerDashboardService,
                private alertService: AlertService,
                private dataUtils: DataUtils,
                private route: ActivatedRoute) {
        this.jhiLanguageService.setLocations( [ 'seller' ] );
    }

    ngOnInit() {
        this.principal.identity().then( (account) => {
            this.account = account;
        } );
        this.load();
        this.sellerService.loadModels().subscribe(
            (res: Response) => {
                this.models = res.json();
            }, (res: Response) => this.onError( res.json() ) );
        this.loadFiles();
    }

    load() {

        this.sellerService.load().subscribe( seller => {
            this.seller = seller;
            console.log( seller )
        } );
    }

    private onError(error) {
        this.alertService.error( error.message, null, null );
    }

    private loadFiles() {
        this.sellerService.loadFiles().subscribe(
            (res: Response) => {
                this.files = res.json();
            }, (res: Response) => this.onError( res.json() ) );
    }

    showUpload() {
        this.upload = true
        console.log( this.upload )
    }

    onNotify(closeUpload: boolean): void {

        this.upload = !closeUpload;
        this.loadFiles();
    }

    touch() {

        this.sellerService.touch().subscribe( response => {

            console.log( response );
            this.alertService.success( 'deviceConfigurerServiceApp.seller.dashboard.touch.title', null, null );
            this.load();
        } );
    }

    byteSize(field) {
        return this.dataUtils.byteSize( field );
    }

    openFile(contentType, field) {
        return this.dataUtils.openFile( contentType, field );
    }

    removeFile(resource: Resource) {
        let c = confirm( "Czy napewno chcesz usunąć plik '" + resource.fileName + "'?" );
        if (c) {
            this.sellerService.removeFile( resource.id ).subscribe(
                (res: Response) => {
                    if (res.ok) {
                        this.loadFiles();
                    }
                }, (res: Response) => this.onError( res.json() ) );
            ;
        }
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/dashboard/seller-dashboard/seller-dashboard.component.ts